import { Star } from "@mui/icons-material";
import useUIStyles from "../../../Hooks/useUIStyles";

const bgColors = {
  pink: "bg-pink-50",
  blue: "bg-blue-50",
  purple: "bg-purple-50",
  green: "bg-green-50"
};

const ReviewCard = ({ review }) => {
  const { heading, title, description } = useUIStyles();
  const { name, initial, location, rating, comment, date, bgColor } = review;

  return <div className={`${bgColors[bgColor]} rounded-lg p-4 cursor-pointer hover:shadow-lg`}>
    <div className="flex items-center mb-2">
      <div className="w-10 h-10 rounded-full bg-gray-600 text-white flex items-center justify-center mr-3">
        <span className="font-medium">
          {initial}
        </span>
      </div>
      <div>
        <div className="font-medium" style={{ ...title }}>
          {name}
        </div>
        <div className="text-sm text-gray-500" style={{ ...description }}>
          {location}
        </div>
      </div>
      <div className="ml-auto">
        <div className="flex">
          {[...Array(5)].map((_, i) =>
            <Star
              key={i}
              size={16}
              fill={i < rating ? "#FFD700" : "none"}
              stroke={i < rating ? "#FFD700" : "#D1D5DB"}
            />
          )}
        </div>
      </div>
    </div>

    <div className="mb-2 font-medium" style={{ ...title }}>
      {comment.title}
    </div>
    <div className="text-sm text-gray-700 mb-4 line-clamp-3" style={{ ...description }}>
      {comment.text}
    </div>

    <div className="text-xs text-gray-500" style={{ ...description }}>
      {date}
    </div>
  </div>;
};

export default ReviewCard;
